let css = require.context("stylesheets")
css.keys().forEach(css)

let img = require.context("images")
img.keys().forEach(img)

// let componentRequireContext = require.context("components", true)
// let ReactRailsUJS = require("react_ujs")
// ReactRailsUJS.useContext(componentRequireContext)

// require('jquery-ui-bundle')
require("javascripts/svg.min.js")
require("javascripts/TweenMax.min.js")
require("javascripts/scripts.js")



// WEBPACK FOOTER //
// app/frontend/packs/application.js